import { useSelector } from '@common/oneclub/store'

export function useWalletList() {
  const defaultWallet = useSelector((state) => state.auth.walletList.find((wallet) => wallet.isDefault))
  const walletList = useSelector((s) => s.auth.walletList)
  return { defaultWallet, walletList }
}
